/* ZMathFunct
Versione 1.1.0 - 04 Febbraio 2025 - Massimiliano Zirilli
                 - NEW: Introdotta funzione che torna il numero di cifre decimali significative di un valore
Versione 1.0.0 - 04 Marzo 2024 - Francesco Ardini
                 Prima versione
*/

export class TZMathFunct
{
  static GetMultiplo(Valore, Divisore, Tipo)
  {
    let Eccesso = 0
    let Difetto = 0
    let Result = Math.trunc(Valore / Divisore) * Divisore
    switch (Tipo)
    {
      case 'Eccesso'    : if (Result < Valore)
                            Result = Result + Divisore
                          break
      case 'Difetto'    : if (Result > Valore)
                            Result = Result - Divisore
                          break
      case 'PiuVicino'  : if (Result < Valore)
                            Eccesso = Result + Divisore
                          else Eccesso = Result
                          if (Result > Valore)
                            Difetto = Result - Divisore
                          else Difetto = Result
                          if (Math.abs(Difetto - Valore) > Math.abs (Eccesso - Valore))
                            Result = Eccesso
                          else Result = Difetto
                          break
    }
    return Result
  }

  static TruncToMultiplo(Valore, Multiplo)
  {
    let Result = Math.trunc(Valore / Multiplo)
    return Result * Multiplo
  }

  static GetNumeroDecimali(Valore)
  {
    let Result = 0
    for(let i = 1; i <= 10; i++)
    {
      let StringValue = (Valore * Math.pow(10,i - 1)).toFixed(1);
      //console.log(StringValue + ' - ' + StringValue.split('.')[1])
      if(StringValue.split('.')[1] != 0)
         Result = i;
    }

    return Result
  }

  static DegToRad(Deg)
  {
    return (Deg / 180) * Math.PI 
  }

  static RadToDeg(Rad)
  {
    return (Rad * 180) / Math.PI
  }

  // PER LE FUNZIONI "LINE", L'OGGETTO "PUNTO" DEVE ESSERE NELLA FORMA {X: ValoreReale, Y: ValoreReale}

  static GetLineEquationFromPoints(Punto1, Punto2)
  {
    let q = null
    let m = null
    let PrimoPunto = Punto1
    let SecondoPunto = Punto2
    if (Punto2.X == 0 && Punto1.X != 0)
    {
      PrimoPunto = Punto2
      SecondoPunto = Punto1
    }
    if (Punto2.X == Punto1.X)
      return {a: Punto1.X}
    q = (PrimoPunto.Y - (SecondoPunto.Y * (PrimoPunto.X / SecondoPunto.X))) / (1 - (PrimoPunto.X / SecondoPunto.X))
    m = (SecondoPunto.Y - q) / SecondoPunto.X
    return {m: m, q: q}
  }

  // a DEVE ESSERE PASSATO SE LA RETTA È PARALLELA AD X
  static IsPointInLine(Punto, m, q, a = null)
  {
    if (a != null)
      return Punto.X == a
    return Punto.Y == m * Punto.X + q
  }
}